module.exports = __webpack_public_path__ + "img/icon2.3d6d3fd8.png";